import React from 'react';
import { ImgUploaderForStyleSettings } from 'components/ImgUploader/ImgUploaderForStyleSettings';
import style from './ThumbItem.module.scss';

interface IProps {
	onClick: () => void;
	selected: boolean;
	isMakeRequest: boolean;
	filePath: Nullable<string>;
	translationId: string;
	sourceUrl: string;
}

export const ThumbImgItem: React.FC<IProps> = React.memo(
	({ onClick, selected, isMakeRequest, filePath, translationId, sourceUrl }) => (
		<div className={`${style.emblaSlide} ${style.emblaSlideThumb} ${selected ? style.isSelected : ''}`}>
			<button
				onClick={onClick}
				className={`${style.emblaSlideInner} ${style.emblaSlideInnerThumb}`}
				type="button">
				{filePath ? (
					<span className={style.emblaSlideThumbnailDiv}>
						<ImgUploaderForStyleSettings
							translationID={translationId}
							photoSize="Small"
							isMakeImageRequest={isMakeRequest}
							loaderSize="big"
							noImageIdIcon="twoHills"
							filePath={selected ? filePath : null}
							isUseInSlider={true}
						/>
					</span>
				) : (
					<img className={style.emblaSlideThumbnailImg} src={sourceUrl} alt="Some photo" />
				)}
			</button>
		</div>
	),
);
